export default __webpack_public_path__ + "static/media/icon_My subscription.d4e3f416.png";